export const esAdmin = {
  'admin.accessRequired': 'Acceso administrativo requerido',
  'admin.actionsDescription': 'Acciones sensibles con permisos mínimos y registro de auditoría.',
  'admin.active': 'Activa',
  'admin.activeCodes': 'Códigos activos',
  'admin.activations': 'Activaciones',
  'admin.admin': 'Admin',
  'admin.adminActivity': 'Actividad administrativa reciente',
  'admin.appliedUsers': 'Entregada a {count} usuarios.',
  'admin.assignMe': 'Asignarme',
  'admin.auditEmpty': 'Sin actividad todavía.',
  'admin.awardTicket': 'Otorgar ticket a {name}',
  'admin.benefit': 'Beneficio',
  'admin.campaigns': 'Campañas',
  'admin.catalog': 'Catálogo',
  'admin.catalogPlans': 'Catálogo de planes',
  'admin.communication': 'Comunicación',
  'admin.console': 'Panel administrativo · {role}',
  'admin.createOffer': 'Crear oferta',
  'admin.csv': 'CSV',
  'admin.days15': '15 días',
  'admin.deactivate': 'Desactivar',
  'admin.deactivateOffer': 'Desactivar {title}',
  'admin.description': 'Descripción',
  'admin.durationDays': '{days} días',
  'admin.editOffer': 'Editar {title}',
  'admin.end': 'Fin',
  'admin.features': 'Funcionalidades, una por línea',
  'admin.featured': 'Destacado',
  'admin.globalNotification': 'Enviar notificación global',
  'admin.globalNotificationDescription':
    'La campaña queda auditada y se procesa en lotes de usuarios.',
  'admin.growth': 'Crecimiento de usuarios',
  'admin.inactive': 'Inactiva',
  'admin.information': 'Información',
  'admin.initialize': 'Inicializar',
  'admin.message': 'Mensaje',
  'admin.month1': '1 mes',
  'admin.month3': '3 meses',
  'admin.month6': '6 meses',
  'admin.mrr': 'MRR estimado',
  'admin.name': 'Nombre',
  'admin.newOffer': 'Nueva oferta',
  'admin.newPassword': 'Nueva contraseña',
  'admin.newThisMonth': 'Nuevos este mes',
  'admin.noName': 'Sin nombre',
  'admin.noTickets': 'No hay tickets en la cola.',
  'admin.offerError': 'Revisa las fechas y los datos de la oferta.',
  'admin.offerRule': 'Activar y desactivar cualquier oferta anterior',
  'admin.operations': 'Operaciones FinanceGo',
  'admin.order': 'Orden',
  'admin.overview': 'Resumen',
  'admin.payment': 'Pago',
  'admin.planActive': 'Plan activo',
  'admin.planError': 'No fue posible actualizar el plan.',
  'admin.planManaged': 'precio y límites administrados por Stripe/FinanceGo',
  'admin.promotions': 'Promociones',
  'admin.pushToo': 'Enviar también como push',
  'admin.referralUsers': 'Usuarios con referidos',
  'admin.referrals': 'Referidos',
  'admin.reminder': 'Recordatorio',
  'admin.remindUser': 'Enviar recordatorio a {name}',
  'admin.reply': 'Respuesta',
  'admin.resetMonth': 'Reiniciar mes',
  'admin.resetPassword': 'Restablecer y cerrar sesiones',
  'admin.rewards': 'Recompensas',
  'admin.role': 'Rol',
  'admin.saveOffer': 'Guardar oferta',
  'admin.search': 'Buscar',
  'admin.sections': 'Secciones administrativas',
  'admin.sendCampaign': 'Enviar campaña',
  'admin.start': 'Inicio',
  'admin.status': 'Estado',
  'admin.statusWaiting': 'Esperando usuario',
  'admin.superadmin': 'Superadmin',
  'admin.support': 'Soporte',
  'admin.supportQueue': 'Cola de soporte',
  'admin.sync': 'Sincronizar',
  'admin.systemVolume': 'Volumen del sistema',
  'admin.ticketCount': '{activated} activados · {tickets} tickets',
  'admin.tickets': 'Tickets',
  'admin.ticketsMonth': 'Tickets del mes',
  'admin.ticketsOpen': 'Tickets abiertos',
  'admin.ticketsUrgent': 'Tickets urgentes',
  'admin.title': 'Título',
  'admin.type': 'Tipo',
  'admin.urgentCount': '{count} urgentes',
  'admin.user': 'Usuario',
  'admin.users': 'Usuarios',
  'admin.usersGrowthError': 'No pudimos cargar el resumen administrativo.',
  'admin.warning': 'Advertencia',
} as const;

export const enAdmin: Record<keyof typeof esAdmin, string> = {
  'admin.accessRequired': 'Administrative access required',
  'admin.actionsDescription': 'Sensitive actions with least privilege and an audit trail.',
  'admin.active': 'Active',
  'admin.activeCodes': 'Active codes',
  'admin.activations': 'Activations',
  'admin.admin': 'Admin',
  'admin.adminActivity': 'Recent administrative activity',
  'admin.appliedUsers': 'Delivered to {count} users.',
  'admin.assignMe': 'Assign to me',
  'admin.auditEmpty': 'No activity yet.',
  'admin.awardTicket': 'Award ticket to {name}',
  'admin.benefit': 'Benefit',
  'admin.campaigns': 'Campaigns',
  'admin.catalog': 'Catalog',
  'admin.catalogPlans': 'Plan catalog',
  'admin.communication': 'Communication',
  'admin.console': 'Admin panel · {role}',
  'admin.createOffer': 'Create offer',
  'admin.csv': 'CSV',
  'admin.days15': '15 days',
  'admin.deactivate': 'Deactivate',
  'admin.deactivateOffer': 'Deactivate {title}',
  'admin.description': 'Description',
  'admin.durationDays': '{days} days',
  'admin.editOffer': 'Edit {title}',
  'admin.end': 'End',
  'admin.features': 'Features, one per line',
  'admin.featured': 'Featured',
  'admin.globalNotification': 'Send global notification',
  'admin.globalNotificationDescription': 'The campaign is audited and processed in user batches.',
  'admin.growth': 'User growth',
  'admin.inactive': 'Inactive',
  'admin.information': 'Information',
  'admin.initialize': 'Initialize',
  'admin.message': 'Message',
  'admin.month1': '1 month',
  'admin.month3': '3 months',
  'admin.month6': '6 months',
  'admin.mrr': 'Estimated MRR',
  'admin.name': 'Name',
  'admin.newOffer': 'New offer',
  'admin.newPassword': 'New password',
  'admin.newThisMonth': 'New this month',
  'admin.noName': 'No name',
  'admin.noTickets': 'There are no tickets in the queue.',
  'admin.offerError': 'Review the offer dates and information.',
  'admin.offerRule': 'Activate this offer and deactivate any previous offer',
  'admin.operations': 'FinanceGo operations',
  'admin.order': 'Order',
  'admin.overview': 'Overview',
  'admin.payment': 'Payment',
  'admin.planActive': 'Active plan',
  'admin.planError': 'The plan could not be updated.',
  'admin.planManaged': 'price and limits managed by Stripe/FinanceGo',
  'admin.promotions': 'Promotions',
  'admin.pushToo': 'Also send as push',
  'admin.referralUsers': 'Users with referrals',
  'admin.referrals': 'Referrals',
  'admin.reminder': 'Reminder',
  'admin.remindUser': 'Send reminder to {name}',
  'admin.reply': 'Reply',
  'admin.resetMonth': 'Reset month',
  'admin.resetPassword': 'Reset and close sessions',
  'admin.rewards': 'Rewards',
  'admin.role': 'Role',
  'admin.saveOffer': 'Save offer',
  'admin.search': 'Search',
  'admin.sections': 'Administrative sections',
  'admin.sendCampaign': 'Send campaign',
  'admin.start': 'Start',
  'admin.status': 'Status',
  'admin.statusWaiting': 'Waiting for user',
  'admin.superadmin': 'Superadmin',
  'admin.support': 'Support',
  'admin.supportQueue': 'Support queue',
  'admin.sync': 'Sync',
  'admin.systemVolume': 'System volume',
  'admin.ticketCount': '{activated} activated · {tickets} tickets',
  'admin.tickets': 'Tickets',
  'admin.ticketsMonth': 'Tickets this month',
  'admin.ticketsOpen': 'Open tickets',
  'admin.ticketsUrgent': 'Urgent tickets',
  'admin.title': 'Title',
  'admin.type': 'Type',
  'admin.urgentCount': '{count} urgent',
  'admin.user': 'User',
  'admin.users': 'Users',
  'admin.usersGrowthError': 'We could not load the administrative overview.',
  'admin.warning': 'Warning',
};
